import { createBrowserRouter } from "react-router-dom";

import WithHeaderLayout from "./layout/WithHeaderLayout";
import WithoutHeaderLayout from "./layout/WithoutHeaderLayout";
import WithFloatingLayout from "./layout/WithFloatingBtn";

import Home from "./pages/home";
import Introduction from "./pages/introduction";
import ServiceIntro from "./pages/serviceIntro";
import ExpectedEffect from "./pages/effect";
import ServiceCase from "./pages/case";
import Inquiry from "./pages/inquiry";
import FAQ from "./pages/faq";
import Application from "./pages/application";
import AppRoot from "./AppRoot";
import PrivacyPolicy from "./pages/terms/PrivacyPolicy";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppRoot />, //  스크롤 처리 등 공통 처리
    children: [
      {
        element: <WithHeaderLayout />,
        children: [
          {
            element: <WithFloatingLayout />,
            children: [
              { index: true, element: <Home /> },
              { path: "features", element: <Introduction /> },
              { path: "solution", element: <ServiceIntro /> },
              { path: "case-studies", element: <ServiceCase /> },
              { path: "help-center", element: <Inquiry /> },
              { path: "FAQ", element: <FAQ /> },
              { path: "efficiency", element: <ExpectedEffect /> },
            ],
          },
          { path: "inquiry-form", element: <Application /> },
        ],
      },

      {
        element: <WithoutHeaderLayout />,
        children: [{ path: "terms/privacy", element: <PrivacyPolicy /> }],
      },
    ],
  },
]);
